import { memo } from 'react';

import { CURRENCY_SYMBOL } from '@/shared/constants';

const CURRENCY_INT_FORMATTER = new Intl.NumberFormat('ro-RO', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const SUP_STYLE = { fontSize: '0.85em', marginTop: 0, paddingTop: 0 } as const;

export interface CurrencyCellProps {
  value: number | null | undefined;
  currency?: string;
  testId?: string;
}

export const CurrencyCell = memo(({ value, testId }: CurrencyCellProps) => {
  if (value == null) return null;

  if (!value) {
    return <span data-testid={testId}>0 {CURRENCY_SYMBOL}</span>;
  }

  const [integer, decimals] = value.toFixed(2).split('.');

  return (
    <span data-testid={testId}>
      <span>{CURRENCY_INT_FORMATTER.format(parseInt(integer))}</span>
      {!!decimals && decimals !== '00' && <sup style={SUP_STYLE}>{decimals}</sup>}
      <span> {CURRENCY_SYMBOL}</span>
    </span>
  );
});
CurrencyCell.displayName = 'CurrencyCell';
